(() => {
  const roots = document.querySelectorAll('[data-dsy-reviews-page]');

  roots.forEach((root) => {
    const filterButtons = [...root.querySelectorAll('[data-dsy-review-filter]')];
    const search = root.querySelector('[data-dsy-review-search]');
    const sort = root.querySelector('[data-dsy-review-sort]');
    const emptyNote = root.querySelector('[data-dsy-review-filter-note]');
    const writeButton = root.querySelector('[data-dsy-write-review]');
    let category = 'all';

    const categoryTerms = {
      funny: ['funny', 'laugh', 'husband', 'expensive', 'difficult', 'bossy', 'hot dog'],
      cultura: ['latina', 'mexico', 'mexican', 'puerto rico', 'boricua', 'cultura', 'tejas'],
      'mom-life': ['mom', 'mama', 'mother', 'mom life'],
      custom: ['custom', 'personalized', 'initial', 'name', 'monogram', 'old english'],
      'game-day': ['game day', 'football', 'baseball', 'soccer', 'team', 'tailgate']
    };

    const reviewCards = () => [...root.querySelectorAll('.jdgm-rev')];

    const applyFilters = () => {
      root.querySelectorAll('.jdgm-medal[aria-label]:not([href])').forEach((medal) => {
        medal.setAttribute('role', 'img');
      });

      const cards = reviewCards();
      const query = (search?.value || '').trim().toLowerCase();
      const terms = categoryTerms[category] || [];
      let shown = 0;

      cards.forEach((card) => {
        const text = card.textContent.toLowerCase();
        const categoryMatch = category === 'all' || terms.some((term) => text.includes(term));
        const searchMatch = !query || text.includes(query);
        const visible = categoryMatch && searchMatch;
        card.hidden = !visible;
        if (visible) shown += 1;
      });

      if (emptyNote) emptyNote.hidden = cards.length === 0 || shown > 0;
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.dsyReviewFilter;
        filterButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        applyFilters();
      });
    });

    search?.addEventListener('input', applyFilters);

    sort?.addEventListener('change', () => {
      const wanted = {
        newest: ['newest', 'most recent'],
        highest: ['highest', 'high rating'],
        lowest: ['lowest', 'low rating']
      }[sort.value];
      const nativeSort = [...root.querySelectorAll('.jdgm-sort-dropdown, select[class*="sort"]')]
        .find((candidate) => [...candidate.options].some((item) =>
          wanted.some((term) => item.textContent.toLowerCase().includes(term))
        ));
      if (!nativeSort || nativeSort === sort) return;
      const option = [...nativeSort.options].find((item) =>
        wanted.some((term) => item.textContent.toLowerCase().includes(term))
      );
      if (option) {
        nativeSort.value = option.value;
        nativeSort.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    writeButton?.addEventListener('click', () => {
      const openNativeReview = (attempt = 0) => {
        const nativeWrite = root.querySelector('.jdgm-write-rev-link, .jdgm-write-review');
        if (!nativeWrite) {
          if (attempt < 10) {
            window.setTimeout(() => openNativeReview(attempt + 1), 500);
          } else {
            window.location.href = 'https://judge.me/reviews/stores/www.dsylifestyle.com';
          }
          return;
        }

        nativeWrite.click();
        nativeWrite.scrollIntoView({ behavior: 'smooth', block: 'center' });

        window.setTimeout(() => {
          const form = root.querySelector('.jdgm-form-wrapper');
          const opened = nativeWrite.getAttribute('aria-expanded') === 'true'
            || /cancel/i.test(nativeWrite.textContent)
            || (form && form.getBoundingClientRect().height > 0);
          if (!opened && attempt < 10) openNativeReview(attempt + 1);
        }, 500);
      };

      openNativeReview();
    });

    const widget = root.querySelector('#judgeme_all_reviews_page');
    if (widget) {
      const observer = new MutationObserver(applyFilters);
      observer.observe(widget, { childList: true, subtree: true });
      window.setTimeout(applyFilters, 1200);
    }
  });
})();
